module.exports = __webpack_public_path__ + "img/vertical_6_1_6005.25b86868.png";